export class BaysRoutingConstants {
    static BAYS_ROUTE = "bays";
}
